import { parseStatementIdAsYearAndQuarter } from '..';

export const formatStatementIdAsYearAndQuarter = (
    statementId: string,
): Maybe<string> => {
    const yearAndQuarter = parseStatementIdAsYearAndQuarter(statementId);

    if (yearAndQuarter === null) {
        return null;
    }

    return `${yearAndQuarter.year} Q${yearAndQuarter.quarter}`;
};
